// ─── App Index Route ───
// /app (exact) — GHE #283 item 3: this used to render a static Phase-1
// "Bienvenido a {{appName}} / Selecciona una lista..." placeholder — no
// tasks, no overdue count, no recent activity — even though My Plani (the
// personal cross-workspace agenda) already exists and is a far better front
// door. Owner decision: redirect to My Plani rather than build a new "today"
// summary here.
//
// ─── GHE #476: the destination now depends on the PERSON ───
// Simple mode makes /app land on the launcher instead. That turns this from a
// static redirect into a user-dependent one, and `simpleMode` lives in React
// context (AuthProvider), not router context — so the `beforeLoad` + `redirect`
// form this replaced cannot read it.
//
// Hence a render-time `<Navigate>`, matching `routes/app.tsx`'s own auth guard,
// which reaches for the same pattern for the same reason. The `beforeLoad` form
// was correct while the answer was identical for everybody; it no longer is.
//
// `search` is still passed through — a stale deep link landing on /app must not
// lose its query string on the way past (the idiom `routes/app/l/$listRef.tsx`
// and `routes/app/s/$spaceRef.tsx` use for their canonical redirects).
//
// The old placeholder copy (`appWelcome.title`, the ONLY consumer of that
// key) was deleted with it; `appWelcome.description` /
// `appWelcome.spaceFallbackName` stay — `routes/app/s/$spaceRef.tsx` reuses
// both for its own "no dedicated space dashboard yet" empty state.

import { createFileRoute, Navigate, useSearch } from '@tanstack/react-router';
import { useAuth } from '../../features/auth/AuthProvider';

export const Route = createFileRoute('/app/')({
  component: AppIndexRedirect,
});

function AppIndexRedirect(): React.JSX.Element | null {
  const { user, isLoading } = useAuth();
  const search = useSearch({ strict: false });

  // Redirecting mid-load would send everyone to My Plani and then bounce
  // simple-mode users to the launcher a tick later — a visible flash of the
  // surface they opted out of. Waiting one render costs nothing: /app is a
  // doorway nobody reads.
  if (isLoading) return null;

  return (
    <Navigate to={user?.simpleMode ? '/app/inicio' : '/app/my-plani'} search={search} replace />
  );
}
